export default __webpack_public_path__ + "img/ehqJtJSa.717f34c1.svg";